/**
 * @generated SignedSource<<ef1b7205b86a42beea1fe19291367192>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BalanceManagement = "POSTPAID" | "PREPAID";
export type CartViewMandatoryAction = "CHECK_ACCOUNT_ELIGIBILITY" | "CHOOSE_ACCOUNT" | "CHOOSE_ELIGIBLE_IFP_PLAN" | "SIGN_IN";
export type CartViewScreen = "EMPTY_SCREEN" | "NO_ACCOUNT_SCREEN" | "OVERVIEW_SCREEN";
export type Segment = "business" | "personal" | "sparkdigitalshop";
import { FragmentRefs } from "relay-runtime";
export type useCartActionFragment$data = {
  readonly cartView: {
    readonly cart: {
      readonly " $fragmentSpreads": FragmentRefs<"shopCartFragment">;
    } | null;
    readonly screen: CartViewScreen;
    readonly mandatoryAction: CartViewMandatoryAction | null;
  };
  readonly me: {
    readonly accountList: ReadonlyArray<{
      readonly accountId: string;
      readonly accountNumber: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly balanceManagement: BalanceManagement | null;
      readonly customerSegment: string;
      readonly segment: Segment;
    }>;
  };
  readonly " $fragmentType": "useCartActionFragment";
};
export type useCartActionFragment$key = {
  readonly " $data"?: useCartActionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCartActionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "channel",
  "variableName": "channel"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cartId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "channel"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCartActionFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "cartId",
          "variableName": "cartId"
        },
        (v0/*: any*/)
      ],
      "concreteType": "CartView",
      "kind": "LinkedField",
      "name": "cartView",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Cart",
          "kind": "LinkedField",
          "name": "cart",
          "plural": false,
          "selections": [
            {
              "args": [
                (v0/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "shopCartFragment"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "screen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mandatoryAction",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountList",
          "kind": "LinkedField",
          "name": "accountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balanceManagement",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerSegment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "segment",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "51d5e73db08e6587f74c0b427a1d9d77";

export default node;
